export default {
	API_URL             : 'app.fresnoirrigation.com/api',
	API_PROTOCOL        : 'https',
	NODE_ENV            : 'production',
	GOOGLE_MAPS_API_KEY : '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',
	PACKAGE_VERSION     : '1.6.4',
};
